import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Modal,
    makeStyles
  } from '@material-ui/core';
import BlankState from '../BlankState';
import Loading from '../Loading';
import React, { Fragment, useState } from 'react'
import { Query } from 'react-apollo';
import { applicationBackpackBuddyQuery, applicationSchoolMarketQuery, districtsQuery } from '../../apollo';
import { sortBy } from 'lodash';
import { get } from 'lodash';
import generateUniqueKey from '../../helpers/generateUniqueKey';
import { goBack } from 'connected-react-router';

function getModalStyle() {
      
    return {
    };
  }
  
  const useStyles = makeStyles((theme) => ({
    paper: {
    },
  }));

 const schoolType = {
    ELEMENTARY: 'Elementary',
    MIDDLE: 'Middle',
    HIGH: 'High',
    NON_TRADITIONAL: 'Non-traditional',
  }

const PrintComponent = (props) => {

    const { match, dispatch } = props;
    const { params } = match;

    const applicationSchoolMarketId = params.id

    const [hideButtons, setHideButtons] = useState(false);


     const types = {
        BRICK_MORTAR: 'Brick and Mortar',
        MOBILE: 'Mobile',
        ALTERNATE: 'Unable to have distributions on school campus and need to explore alternate options',
      }

    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);
  
    return (
        <Query
        query={applicationSchoolMarketQuery}
        variables={{ applicationSchoolMarketId: applicationSchoolMarketId }}
        fetchPolicy="network-only"
      >
        {({ loading, data, error }) => {
          if (loading) return <Loading />;
          if (error) return <BlankState title="Error" subtitle="There was an error loading" />;
          
          const body = data.applicationSchoolMarket;
  
          return (
            <Grid
            id='print'
            style={{height: '100%', minHeight: '100%', minWidth: '100%'}}

            >
                <div style={modalStyle} className={classes.paper}>
                <div >
                <b>Application Details:</b>
                <div>
                    {body.term.termFormattedShort}
                </div>
                <h4 className="purple-headline boxed-in">School Information</h4>
                <div>
                    <b>Did your site participate in this program last year?&nbsp;</b>
                    {body.new == true? 'No': 'Yes'}
                </div>
                <div>
                    <b>School Type:&nbsp;</b>
                    {schoolType[body.school.type]}
                </div>
                <div>
                    <b>School Name:&nbsp;</b>
                    {body.school.name}
                </div>
                <div>
                    <Query query={districtsQuery}>
                        {({ loading: queryLoading, error: queryError, data }) => {
                        const districtOptions = sortBy(get(data, 'allDistricts', []).map(district => ({
                            label: district.name,
                            value: district.districtId,
                        })), 'label');

                        let placeholder = '';
                        if (queryLoading) {
                            placeholder = 'Loading...';
                        }
                        if (queryError) {
                            placeholder = 'Error loading districts, please refresh.';
                        }

                        return (
                            <div>
                                <b>School District:&nbsp;</b>
                                {placeholder == ''? districtOptions.find(el => el.value == body.school.districtId).label: placeholder}
                            </div>
                        );
                        }}
                    </Query>
                </div>
                <div>
                    <b>Organization Type:&nbsp;</b>
                    {body.organizationType}
                </div>
                <div>
                    <b>If you are a 501(c)(3) organization, please list the schools and/or school district (including address), you are partnered with below. If you are a school, please skip this section.&nbsp;</b>
                    {body.nonProfitOrganizations}
                </div>
                <div>
                    <b>Address:&nbsp;</b>
                    {body.school.address1}
                </div>
                <div>
                    <b>Address 2:&nbsp;</b>
                    {body.school.address2}
                </div>
                <div>
                    <b>City:&nbsp;</b>
                    {body.school.city}
                </div>
                <div>
                    <b>State:&nbsp;</b>
                    {body.school.state}
                </div>
                <div>
                    <b>Zip:&nbsp;</b>
                    {body.school.zip}
                </div>
                <div>
                    <b>Grades Served:&nbsp;</b>
                    {body.school.gradesServed.join(', ')}
                </div>
                
                <div>
                    <b>Total Enrollment:&nbsp;</b>
                    {body.numTotalEnrollment}
                </div>
                <div>
                    <b>Number of Students Receiving Reduced Lunch:&nbsp;</b>
                    {body.numReducedLunch}
                </div>
                <div>
                    <b>Number of Students Receiving Free Lunch:&nbsp;</b>
                    {body.numFreeLunch}
                </div>
                <div>
                    <b>Would you be willing to help Houston Food Bank with media events?&nbsp;</b>
                    {body.willHelpMediaEvents  == true? 'Yes': 'No'}
                </div>
                <div>
                    <b>Would you be willing to pass out info about other Houston Food Bank&#39;s programs if provided?&nbsp;</b>
                    {body.willDistributeInfo  == true? 'Yes': 'No'}
                </div>
                <div>
                    <b>Your Market Type:&nbsp;</b>
                    {types[body.marketType]}
                </div>
                <div>
                    <b>Your Market Distributions Frequency:&nbsp;</b>
                    {body.operatingFrequency}
                </div>
                <div>
                    <b>Preferred Market Distribution Day (subject to availability):&nbsp;</b>
                    {body.preferredDistributionDay}
                </div>
                <div>
                    <b>Preferred Market Distribution Time:&nbsp;</b>
                    {body.preferredDistributionTime}
                </div>
                <div>
                    <b>Secondary Preferred Market Distribution Day (subject to availability)&nbsp;</b>
                    {body.secondaryPreferredDistributionDay}
                </div>
                <div>
                    <b>Secondary Preferred Market Distribution Time:&nbsp;</b>
                    {body.secondaryPreferredDistributionTime}
                </div>
                <h4 className="purple-headline boxed-in">Primary Point of Contact</h4>
                <div>
                    <b>First Name&nbsp;</b>
                    {body.school.primaryPointOfContact.firstName}
                </div>
                <div>
                    <b>Last Name&nbsp;</b>
                    {body.school.primaryPointOfContact.lastName}
                </div>
                <div>
                    <b>Job Title (optional)&nbsp;</b>
                    {body.school.primaryPointOfContact.title}
                </div>
                <div>
                    <b>Phone&nbsp;</b>
                    {body.school.primaryPointOfContact.phone}
                </div>
                <div>
                    <b>Email&nbsp;</b>
                    {body.school.primaryPointOfContact.email}
                </div>
                <h4 className="purple-headline boxed-in">Principal</h4>
                <div>
                    <b>First Name&nbsp;</b>
                    {body.school.principal.firstName}
                </div>
                <div>
                    <b>Last Name&nbsp;</b>
                    {body.school.principal.lastName}
                </div>
                <div>
                    <b>Job Title (optional)&nbsp;</b>
                    {body.school.principal.title}
                </div>
                <div>
                    <b>Phone&nbsp;</b>
                    {body.school.principal.phone}
                </div>
                <div>
                    <b>Email&nbsp;</b>
                    {body.school.principal.email}
                </div>
                <h4 className="purple-headline boxed-in">The Agreement</h4>
                <div>
                    <b>Agreement Sign:&nbsp;</b>
                    {body.nameSignFirst}
                </div>
                <div>
                    <b>Nondiscrimination Sign:&nbsp;</b>
                    {body.nameSignSecond}
                </div>
                <div>
                    <b>Program Sign:&nbsp;</b>
                    {body.nameSignThird}
                </div>
                </div>
                <DialogTitle className="register-info" style={{ textAlign: 'center' }}>
                
                </DialogTitle>
                <DialogContent className="register-info">
                {!hideButtons && <Grid container spacing={2}>
                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                    
                    <Button
                        onClick={() => {
                            setHideButtons(true);
                            setTimeout(() => {
                                window.print();
                                setHideButtons(false);
                            }, 500);
                        }}
                        color="secondary"
                        variant="outlined"
                    >
                        Print Confirmation
                    </Button>
                    </Grid>
                </Grid>}
                {!hideButtons && <DialogActions
                    style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 32 }}
                >
                    <Button onClick={() => dispatch(goBack())} color="primary" variant="outlined">
                    Close
                    </Button>
                </DialogActions>}
                </DialogContent>
                </div>
            </Grid>
          );
        }}
      </Query>
      
    );
  };
  

export default PrintComponent;